import React from 'react';
import styles from './UpdateSuccessModal.scss';
import PropTypes from 'prop-types';
import CSSModules from "react-css-modules";
import SunbitDialog from "../../../components/common/material/Dialog";
import RaisedButton from "../../../components/common/material/RaisedButton";
import Button from "../../../components/common/material/Button";
import {FormattedMessage} from "react-intl";


export const ATPSuccessActions ={
  backToSettings: 'backToSettings',
  gotToAccounts : 'gotToAccounts'
};

@CSSModules(styles, {allowMultiple: true})
class UpdateSuccessDialog extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return  (
      <SunbitDialog active={this.props.active} theme={{dialog:styles.dialogContainer}}>
      <div styleName={'successIcon'}/>
        <div data-at='AtpUpdateSuccessTitle' styleName={'subtitle'}><FormattedMessage id={'atpUpdate.success.dialog.title'}/></div>
        <div data-at='AtpUpdateSuccessContent' styleName={'content'}>
          <FormattedMessage id={'atpUpdate.success.dialog.content'}/>
        </div>
        <RaisedButton dataAt={'successBackToHomepagesBtn'} onClick={() => this.props.handleAction(ATPSuccessActions.gotToAccounts)} styleName = {'baseBtn'} primary={true}>
          <FormattedMessage id={'atpUpdate.success.dialog.backToAccountsBtn'}/>
        </RaisedButton>
        <Button data-at={'successBackToSettingsBtn'} onClick={() => this.props.handleAction(ATPSuccessActions.backToSettings)} theme={{neutral:styles.secondaryBtn}} styleName={'baseBtn'}>
          <FormattedMessage id={'atpUpdate.success.dialog.backToSettingBtn'}/>
        </Button>
    </SunbitDialog>
    );

  }

}

UpdateSuccessDialog.propTypes = {
  handleAction : PropTypes.func,
  active : PropTypes.bool
};


export default UpdateSuccessDialog;



// WEBPACK FOOTER //
// ./src/card/CardDialogs/UpdateSuccessModal/UpdateSuccessDialog.js